"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const Observable_1 = require("rxjs/Observable");
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const emptyMenuItem_1 = require("./emptyMenuItem");
exports.BUTTONMENU_TOKEN = new core_1.OpaqueToken('buttonMenueValue');
/**
 * Default implementation for the button menu
 * @class DefaultMenuProvider
 * @classdesc Default implementation for the button menu
 * @author insite-gmbh
 */
let DefaultMenuProvider = class DefaultMenuProvider {
    /**
     * constructor.
     * @param {Array<IMenuItem>} _menuItems menu configuration.
    */
    constructor(_menuItems, _router) {
        this._menuItems = _menuItems;
        this._router = _router;
        /**
         * Get informed if the menu selection was changed. This will be called from the select from code methods to
         * handle it in the menu components.
         */
        this.selectionChangedNotifier = new core_1.EventEmitter();
        /**
         * Number of entries per given level (e.g. level = line, level = rootElements)
         */
        this.maxEntriesPerLevel = 8;
        this.fillTheGaps();
        this._subscribtion = this._router.events
            .subscribe((ev) => {
            if (this._lastUrl != ev.url)
                console.log(`Route changed to ${ev.url}`, ev);
            if (ev instanceof router_1.NavigationEnd) {
                this._lastUrl = ev.url;
                this.selectByUrl(ev.url);
            }
            else {
                this.selectByUrl(this._lastUrl);
            }
        });
    }
    /**
     * Subscribe to the menues, to get informed if the menus get changing
     * @method subscribeToEntriesFor
     * @param {IMenuItem} parent parent menu (null = main menu)
     */
    subscribeToEntriesFor(parent = null) {
        if (parent == null)
            return Observable_1.Observable.from(new Array(this._menuItems));
        return Observable_1.Observable.from(new Array(this._menuItems[this._menuItems.indexOf(parent)].childs));
    }
    /**
     * This mehtod will be called if a submenu button was clicked.
     * @method applySelectAction
     * @param {IMenuItem} parent parent menu (null = main menu)
     * @return {Promise<boolean>} return true if action completed successfully, otherwise false.
     */
    applySelectAction(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._router.url != item.action && item.action.length > 0)
                return yield this._router.navigate([item.action]);
            return false;
        });
    }
    /**
     * Call the method to select a menu from code byit's buttons
     * @method selectByButton
     * @param {number} parent main menu button id
     * @param {number} child sub menu button id
     */
    selectByButton(parent, child = -1) {
        let selected = this._menuItems[parent];
        if (child >= 0) {
            let childItem = selected.childs[child];
            if (childItem != null)
                this.setSelection(selected.childs, childItem);
        }
        if (selected != null)
            this.selectionChangedNotifier.emit(selected);
    }
    /**
     * Call the method to select a menu from code byit's buttons
     * @method selectByUrl
     * @param {number} parent main menu button id
     * @param {number} child sub menu button id
     */
    selectByUrl(url) {
        this._menuItems.forEach((entry, index) => {
            let found = false;
            let parent = entry;
            parent.childs.forEach((child, cidx) => {
                if (child.action == url) {
                    this.selectByButton(index, cidx);
                    found = true;
                    return;
                }
            });
            if (found)
                return;
        });
    }
    setSelection(childs, item) {
        childs.forEach(b => { b.isSelected = b == item; });
    }
    fillTheGaps() {
        this._menuItems.forEach(entry => {
            entry.provider = this;
            let numberOFEntries = this.maxEntriesPerLevel;
            let dmi = entry;
            let length = dmi.childs.length;
            let max = dmi.childs.find(x => x.id > numberOFEntries);
            let childs = dmi.childs.reverse();
            let current = childs.pop();
            dmi.childs = new Array();
            if (max != null)
                numberOFEntries += numberOFEntries;
            if (current != null)
                current.provider = this;
            for (let i = 0; i < numberOFEntries; i++) {
                if (current != null) {
                    if (current.id != i) {
                        dmi.childs.push(new emptyMenuItem_1.EmptyMenuItem(i, entry));
                    }
                    else {
                        dmi.childs.push(current);
                        current = childs.pop();
                        if (current != null)
                            current.provider = this;
                    }
                }
                else
                    dmi.childs.push(new emptyMenuItem_1.EmptyMenuItem(i, entry));
            }
        });
    }
};
DefaultMenuProvider = __decorate([
    __param(0, core_1.Inject(exports.BUTTONMENU_TOKEN)),
    __metadata("design:paramtypes", [Array,
        router_1.Router])
], DefaultMenuProvider);
exports.DefaultMenuProvider = DefaultMenuProvider;
